<template>
  <div>
    <div class="tabDiv">
      <div style="width: 480px">
        <div><span class="tabDiv_span">活动主题：</span>{{activityTheme}}</div> 
        <div @click="looktgsh()"><span class="tabDiv_span">审核通过：</span>{{approvedCount}}</div>
        <div><span class="tabDiv_span">活动时间：</span>{{activityTimes1}}</div>
      </div>
      <div style="width: 333px">
        <div><span class="tabDiv_span">上限人数：</span>{{upperLimit}}</div>
        <div><span class="tabDiv_span">报名人数：</span>{{signUpCount}}</div>
        <div><span class="tabDiv_span">未审核：</span>{{notReviewedCount}}</div>
      </div> 
    </div>
    <div style="width: 333px">
      <el-button type="success" @click="shenhefun" v-if="readonlyAll != true">批量审核</el-button>
      <el-button type="primary" @click="daochu">导出</el-button>
    </div> 
    <el-table :data="lists" ref="table" highlight-current-row style="margin-top: 20px" border
      :row-key="getRowKeys" type="selection" @selection-change="handleSelectionChange">
      <el-table-column type="selection" :reserve-selection="true" :selectable="checkSelectable"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名"  width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="sex" align="center" width="50" label="性别">
        <template slot-scope="scope">
            <span v-if="scope.row.sex == 0">男</span>
            <span v-if="scope.row.sex == 1">女</span> 
        </template> 
      </el-table-column> 
      <el-table-column prop="birth" align="center" label="出生年月" width="150" :show-overflow-tooltip="true"></el-table-column> 
      <el-table-column prop="idCode" align="center" label="身份证号" width="150" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="address" align="center" label="家庭地址" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="phone" align="center" label="联系电话" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="education" align="center" width="70" label="学历" :show-overflow-tooltip="true">
        <template slot-scope="scope">
        <span v-if="scope.row.education == 0">初中</span>
        <span v-if="scope.row.education == 1">高中</span>
        <span v-if="scope.row.education == 2">职校</span>
        <span v-if="scope.row.education == 3">专科</span>
        <span v-if="scope.row.education == 4">本科</span>
        <span v-if="scope.row.education == 5">研究生</span>
        <span v-if="scope.row.education == 6">博士</span>
        <span v-if="scope.row.education == 7">其他</span>
      </template> </el-table-column>
      <el-table-column prop="operation" label="操作" align="center" width="80px" fixed="right">
        <template scope="scope">
          <el-tooltip class="item" effect="light" content="查看" placement="top-start">
            <button style="color:skyblue"  class="iconfont icon-chakan tabBtn"
              @click="lookPersonDetail(scope.row.id)" ></button>
          </el-tooltip> 
        </template>
      </el-table-column>
    </el-table>
    <br/>
    <el-checkbox v-model="allCheck" @change="allCheckEvent">全选所有</el-checkbox>&emsp;
    <!-- 分页功能 --> 
    <el-pagination
      :page-size="pageConfig.pageSize" 
      layout="total, prev, pager, next, jumper" 
      @current-change="handleCurrentChange"
      :total="pageConfig.total"></el-pagination>
    <!--查看人员弹框-->
      <el-dialog title="查看" :visible.sync="dialogFormVisible" width="995px" append-to-body>
        <el-form :model="lookPersonForm" label-width="180px" style="position: relative;">  
          <el-form-item label="姓名："> 
            <el-input class="form_input1" disabled v-model="lookPersonForm.name" ></el-input>
          </el-form-item>
          <el-form-item label="性别：" >
            <el-select class="form_input1" disabled v-model="lookPersonForm.sex" placeholder="请选择">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select> 
          </el-form-item> 
          <el-form-item label="出生年月：" prop="name">
            <el-date-picker 
              style="width:300px"
              disabled
              v-model="lookPersonForm.birth"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择出生年月"
            ></el-date-picker>
          </el-form-item> 
          <el-form-item label="身份证号：" prop="idCode">
            <el-input class="form_input1" disabled v-model="lookPersonForm.idCode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input class="form_input" disabled v-model="lookPersonForm.phone" autocomplete="off"></el-input>
          </el-form-item> 
          <el-form-item label="文化程度：" >
            <el-select class="form_input" disabled v-model="lookPersonForm.education">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="家庭地址：">
            <el-input class="form_input" disabled v-model="lookPersonForm.address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label-width="0px;width: 200px;" class="toux">
            <!-- <img :src="egImg" alt=""> -->
            <img alt
            :src=" lookPersonForm.photo == null? egImg :lookPersonForm.photo"
            style="width:170px;height:150px;vertical-align: top;margin-left: 10px;"/>
            <div style="text-align:center;width:200px;">头像</div>
          </el-form-item> 
          <el-form-item>
            <div class="footer"> 
              <el-button type="info" @click="clearPersonForm()">取 消</el-button>
            </div>
          </el-form-item> 
        </el-form> 
      </el-dialog> 
      <el-dialog title="审核通过" :visible.sync="dialogVisible" width="70%" :before-close="handleClose" append-to-body>
        <el-table :data="tongguolists" highlight-current-row style="margin-top: 20px" border>
          <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
          <el-table-column prop="name" align="center" label="姓名"  width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sex" align="center" width="50" label="性别">
            <template slot-scope="scope">
                <span v-if="scope.row.sex == 0">男</span>
                <span v-if="scope.row.sex == 1">女</span> 
            </template> 
          </el-table-column>  
          <el-table-column prop="idCode" align="center" label="身份证号" width="150" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" align="center" label="家庭地址" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="phone" align="center" label="联系电话" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="education" align="center" width="70" label="学历" :show-overflow-tooltip="true">
            <template slot-scope="scope">
            <span v-if="scope.row.degreeOfEducation == 0">初中</span>
            <span v-if="scope.row.degreeOfEducation == 1">高中</span>
            <span v-if="scope.row.degreeOfEducation == 2">职校</span>
            <span v-if="scope.row.degreeOfEducation == 3">专科</span>
            <span v-if="scope.row.degreeOfEducation == 4">本科</span>
            <span v-if="scope.row.degreeOfEducation == 5">研究生</span>
            <span v-if="scope.row.degreeOfEducation == 6">博士</span>
            <span v-if="scope.row.degreeOfEducation == 7">其他</span>
          </template> </el-table-column>
          <el-table-column prop="operation" label="操作" align="center" width="80px" fixed="right">
            <template scope="scope">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button style="color:skyblue"  class="iconfont icon-chakan tabBtn"
                  @click="lookPersonDetail(scope.row.id)" ></button>
              </el-tooltip> 
            </template>
          </el-table-column>
        </el-table> 
        <!-- 分页功能 --> 
        <el-pagination
          :page-size="pageConfig2.pageSize" 
          layout="total, prev, pager, next, jumper" 
          @current-change="handleCurrentChange2"
          :total="pageConfig2.total"></el-pagination>
        </el-dialog>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp.js";
import { sskldApi } from "@/api/http";
export default {
  props: ["rowid","readonlyApproval","readonlyAll"],
  data(){
    return{
      id: this.rowid,
      dialogVisible:false,
      listLoading: false,
      multipleSelectionAll: [],//所有选中的数据包含跨分页数据
      allCheck: false,
      getRowKeys (row) {
        return row.id;
      }, 
      readonlyshry:this.readonlyApproval,
      egImg:require("../../../assets/images/partyMemberManagementcopy/imgjia.png"),
      options:[
        {label:'初中',value:'0'},
        {label:'高中',value:'1'},
        {label:'职校',value:'2'},
        {label:'专科',value:'3'},
        {label:'本科',value:'4'},
        {label:'研究生',value:'5'},
        {label:'博士',value:'6'},
        {label:'其他',value:'7'},
        {label:'职校',value:'8'}, 
      ],
      lookPersonForm:{},
      dialogFormVisible:false, 
      activityTimes:[],
      shenheform:{},
      upperLimit:[],
      lists:[],
      gridData:[],
      activityTheme: "",
      activityTimes1: "",
      upperLimit: "",
      signUpCount: "",
      approvedCount: "",
      notReviewedCount: "",
      tongguolists:[],
      pageConfig2: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      pageConfig: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
    }
  },
  watch: {
    // 分页全选-监听数据变化
    lists: {
      handler (value) {
        if (this.allCheck) {
          this.lists.forEach(row => {
            if (row) {
              this.$refs.table.toggleRowSelection(row, true)
            }
          });
        }
      },
      deep: true
    },
  },
  methods:{ 
    looktgsh(){
      this.dialogVisible = true;
      this.getApproveInfo()
    },
    closettgtable(){
      this.dialogVisible = false;
      this.tongguolists = [];
    },
    // 分页全选-选中框改变事件
    handleSelectionChange(val) {
      // 数据去重
      this.multipleSelectionAll = this.reduceSame(val);
      // 选中所有选择框时勾选全选按钮
      if (this.multipleSelectionAll.length == this.total) {
        this.allCheck = true;
      }
      // 将row是对象数组数据转换为字符串
      this.multipleSelectionAll = this.multipleSelectionAll.map(function (val) {
        return val.id;
      }).toString();
      // 选中后的数据
      console.log(this.multipleSelectionAll)
    },
    // 分页全选-全选按钮change事件
    allCheckEvent () {
      let _this = this;
      if (_this.allCheck) {
        // 全选选中时当前页所有数据选中
        _this.lists.forEach(row => {
          if (row) {
            _this.$refs.table.toggleRowSelection(row, true);
          }
        });
      } else {
        _this.$refs.table.clearSelection();
      }
    },
    // 分页全选-全选时禁用选择框
    checkSelectable (row, index) {
      return !this.allCheck;
    },
    // 数组对象去重
    reduceSame: function (arr) {
      let obj = {};
      return arr.reduce(function (prev, item) {
        obj[item.id] ? "" : (obj[item.id] = 1 && prev.push(item))
        return prev
          ;
      }, []);
    },  
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.getUnApproveInfo();
        })
        .catch(_ => {});
    },
    // 关闭查看人员弹框
    clearPersonForm(){
      this.dialogFormVisible = false;
      this.lookPersonForm = {};
      this.checkList = []; 
    }, 
    // 获取参加人员详情
    lookPersonDetail(Pid){
      this.dialogFormVisible = true;
      this.checkList = []
      if(Pid){
        post("/admin/serviceItemsPerson/info/getServiceItemsPerson", {
          id: Pid,
        }).then((res) => { 
          if(res.code == 200){  
            this.lookPersonForm = res.content;  
            console.log("lookPersonForm",this.lookPersonForm);  
          }else{
            this.$message({ message: "获取参加人员详情失败", type: "error" });
          }  
          
        });
      }  
    }, 
    async daochu() {
      let data = { 
        serviceItemsId:this.id,
        };
        let res = await sskldApi.exportServiceItemsPerson(data);
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const fileName = "服务项目报名人员.xls";
        const linkNode = document.createElement("a");
        linkNode.download = fileName; //a标签的download属性规定下载文件的名称
        linkNode.style.display = "none";
        linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
        document.body.appendChild(linkNode);
        linkNode.click(); //模拟在按钮上的一次鼠标单击
        URL.revokeObjectURL(linkNode.href); // 释放URL 对象
        document.body.removeChild(linkNode);
    },
    shenhefun(){
      this.$confirm('确定执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var promes = []
        var array = this.multipleSelectionAll.split(",");
        array.forEach(e => {
            promes.push({
                approvalStatus: '1',
                id: e
            }); 
        }); 
        post("/admin/serviceItemsPerson/info/batchUpdate", promes).then((res) => {
          // console.log(res);
          if(res.code == 200){
            this.$message({
              message: res.message,
              type: "success",
            });
            this.lists = []
            this.getUnApproveInfo()
          }else{
            this.$message({
              message: res.message,
              type: "error",
            });
          }
          
        });
      })
      
    },
    shenheDialog() {
      this.activityTimes = [];
      post("/admin/serviceItems/info/getServiceItems", {
        id: this.id,
      }).then((res) => {
        // console.log(res);
        this.shenheform = res.content;
        if(res.content.startActivityTime !== null && res.content.startActivityTime !== null) {
        this.activityTimes.push(res.content.startActivityTime);
        this.activityTimes.push(res.content.endActivityTime);
        }
        // console.log(this.activityTimes);
        this.platformcheckList = res.content.publishPlatform.split(",");
      });
    },
    // 审核人员保存
    shenheSave() {
      post("/admin/serviceItems/info/updateServiceItems", {
        id: this.id,
        approvalStatus: this.shenheform.approvalStatus,
        approvalOpinion: this.shenheform.approvalOpinion,
      }).then((res) => { 
        // console.log(res);
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getUnApproveInfo();
    },
    //分页2
    handleCurrentChange2(val) {
      this.pageConfig2.pageNo = val;
      this.getApproveInfo();
    },
    getApproveInfo(){
      this.lists = []
      console.log('rowid',this.rowid);
      // 获取服务人员列表
      post("/admin/serviceItemsPerson/info/listServiceItemsPerson", {
        serviceItemsId: this.rowid,
        approvalStatus:'1',
        pageNo: this.pageConfig2.pageNo,
        pageSize: this.pageConfig2.pageSize,
      }).then((res) => {
        if(res.code == 200){  
          this.tongguolists = res.content.list; 
          this.pageConfig2.total = res.content.count;
        }  
      });
    },
    getUnApproveInfo(){
      this.lists = []
      console.log('rowid',this.rowid);
      // 获取服务人员列表
      post("/admin/serviceItemsPerson/info/listServiceItemsPerson", {
        serviceItemsId: this.rowid,
        approvalStatus:'0',
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
      }).then((res) => {
        if(res.code == 200){  
          this.lists = res.content.list; 
          this.pageConfig.total = res.content.count;
        }  
      });
      // 获取列表上面的内容
      post("/admin/serviceItemsPerson/info/getCountByServiceItemsId",{
        serviceItemsId: this.id
      }).then(res => {
        // console.log(res)
            //审核通过数量
            this.approvedCount = res.content.approvedCount;
            //未审核数量
            this.notReviewedCount = res.content.notReviewedCount;
             //报名人数
            this.signUpCount = res.content.signUpCount;
      })
      post("/admin/serviceItems/info/getServiceItems",{
        id: this.id
      }).then(res => {
        // console.log(res)
        this.activityTheme = res.content.activityTheme;
        if(res.content.startActivityTime && res.content.endActivityTime) {
          this.activityTimes1 = res.content.startActivityTime + '-' + res.content.endActivityTime;
        }
        this.upperLimit = res.content.upperLimit;
      })
    },
    getData(){
      this.shenheform = {}
    },
  },
  mounted(){
    console.log('info',this.rowid,"++",this.readonlyAll);
    this.getUnApproveInfo();
  }
}
</script>

<style lang="less">
.form_input{
  width: 600px;
}
.el-form-item{
  margin-top: 20px;
}
.footer{ 
  text-align: center;
  margin-left: -140px;
}
.tabDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.tabDiv div { 
  margin-bottom: 16px;
  font-size: 16px;
}
.tabDiv .tabDiv_span {
  display: inline-block;
  width: 150px;
  text-align: right; 
  font-size: 16px;
}
</style> 